/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
// import { useAssembliesByQuoteId } from "../Store/entities/assemblies/hooks";
import { Col, Container, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock, faTrashAlt, faUnlock } from "@fortawesome/free-solid-svg-icons";
import Table from '../Parts/Table';
import { useQuoteById, useQuoteTypeNameByQuoteId, useQuoteTypes } from "../Store/entities/quotes/hooks";
import Button from "../Parts/Button";
import { QuoteTypeNames } from "../powershadesApiTypes";
import { UsePortalDispatch, UsePortalSelector } from "../Store";
import {
	deleteAssemblies,
	selectOutdoorAssembliesByQuoteId,
	setAssembliesUnlocked,
	setAssembliesSelected
} from "../Store/entities/assemblies";
import { fakeRootType } from "../FakeRootType";
import COROutdoorTableRow from "./COROutdoorTableRow";
import { useCurrentMultiplier } from "../Store/entities/multipliers/hooks";
import SelectBox from "./NewItems/SelectBox";

type COROutdoorTableProps = {
	quoteId: number;
	unlockShadeBySequenceId: (sequenceId: number) => void;
	ROOT: fakeRootType;
};

const COROutdoorTable = (props: COROutdoorTableProps) => {
	const {
		quoteId,
		unlockShadeBySequenceId,
		ROOT
	} = props;

	const outdoorAssemblies = UsePortalSelector(selectOutdoorAssembliesByQuoteId(quoteId));
	const selectedCOROutdoorAssemblies = outdoorAssemblies.filter((assembly) => assembly.selected);

	const quoteMeta = useQuoteById(quoteId);
	const quoteTypeId = quoteMeta?.quote_type_id;
	const quoteTypes = useQuoteTypes();
	const currentQuoteType = (quoteTypes.find((qt) => qt.id === quoteTypeId)?.name ?? "CEDIA") as QuoteTypeNames;
	// const selectedAssemblies =
	const isEditable = quoteMeta.editable;

	const dispatch = UsePortalDispatch();
	const quoteType = useQuoteTypeNameByQuoteId(quoteId);

	const currentMultiplier = useCurrentMultiplier(quoteId);
	const { label, currency } = currentMultiplier;

	const columns: {
		displayName: string;
	}[] = [
		{
			displayName: "Unlock/Select",
		},
		{
			displayName: "Room Name",
		},
		{
			displayName: "Shade Name",
		},
		{
			displayName: "Direction",

		},
		{ displayName: "Fabric" },
		{ displayName: "Side Channels" },
		{
			displayName: "Width",
		},
		{
			displayName: "Height",

		},
		{
			displayName: `${label} (${currency})`
		},
		{
			displayName: "Actions",
		}
	];

	const {
		alert,
		toast
	} = ROOT;

	const selectedAssemblySeqIds = selectedCOROutdoorAssemblies.map((a) => a.sequence_id);
	const onDelete = () => {
		const deletingShadeCount = selectedCOROutdoorAssemblies.length;
		alert({
			title: 'Are you sure you want to delete this shade?',
			text: `You are about to delete ${deletingShadeCount} shades! There's no way to undo this.`,
			icon: 'warning',
			quoteType,
		})
			.then(() => {
				dispatch(deleteAssemblies({
					quoteId,
					sequenceIds: selectedAssemblySeqIds,
				})).then(() => {
					toast(`${deletingShadeCount} shades deleted`, {
						type: 'success',
					});
				}).catch(() => {
					toast(`Deletion of ${deletingShadeCount} shades failed`, {
						type: 'info',
					});
				});
			})
			.catch(() => {
				toast(`Deletion of ${deletingShadeCount} shades canceled`, {
					type: 'info',
				});
			});
	};

	const massTableAction = (
		<Container className="local-bootstrap">
			<Row className="g-0">
				<Col key="a2">
					<Button
						title="Delete"
						size="sm"
						hoverColor={currentQuoteType}
						fullWidth
						color="light"
						onClick={() => onDelete()}
					>
						<FontAwesomeIcon icon={faTrashAlt} />
					</Button>
				</Col>
			</Row>

		</Container>
	);
	if (outdoorAssemblies.length === 0) {
		return null;
	}

	const isAllCOROutdoorShadesUnlocked = outdoorAssemblies.every((a) => a.unlocked);
	const unlockAllShades = () => {
		dispatch(setAssembliesUnlocked({
			quoteId,
			sequenceIds: outdoorAssemblies.map((a) => a.sequence_id),
			unlocked: true,
		}));
	};

	return (<div
		className="quote-table"
		style={{
			overflowX: 'auto', overflowY: 'hidden', marginBottom: '2em'
		}}
	>
		<Table
			quoteType={currentQuoteType}
			className="quote-rows-table-coroutdoor"
			noTBody
			style={{ width: '100%', zIndex: '22' }}
		>
			<tbody style={{ zIndex: 900 }}>
				<tr className="bold-row">
					<th className={currentQuoteType} colSpan={1} />
					<th className={currentQuoteType} colSpan={9}>
						<div
							className={`table-header ${currentQuoteType}`}
							style={{ textAlign: 'center' }}
						>
							Outdoor Shades Mass Edit
						</div>
					</th>
				</tr>
				<tr>
					<th colSpan={1}>
						Select
					</th>
					<th colSpan={1}>
						Room Name
					</th>
					<th colSpan={1}>
						Shade Name
					</th>
					<th colSpan={1}>
						Shade Type
					</th>
					<th colSpan={1}>
						Fabric
					</th>
					<th colSpan={1}>
						Side Channels
					</th>
					<th colSpan={1}>
						Width
					</th>
					<th colSpan={1}>
						Height
					</th>
					<th colSpan={1}>
						Actions
					</th>
					<th colSpan={1}>
						Apply
					</th>
				</tr>
				<tr>
					<th colSpan={1} >
						<SelectBox
							onChange={(e) => {
								const sequenceIds: number[] = [];
								(outdoorAssemblies.filter((a) => a.unlocked)
									.map((fa) => sequenceIds.push(fa.sequence_id)));
								dispatch(setAssembliesSelected({
									quoteId, sequenceIds, selected: e.target.checked
								}));
							}}
						/>
					</th>
					<th colSpan={1} />
					<th colSpan={1} />
					<th colSpan={1} />
					<th colSpan={1} />
					<th colSpan={1} />
					<th colSpan={1} />
					<th colSpan={1} />
					<th colSpan={1}>{massTableAction}</th>
					<th colSpan={1} />
				</tr>
				<tr className="bold-row">
					<th className={currentQuoteType} colSpan={1}>
						<div style={{ textAlign: "center" }}>
							{isEditable && (
								<span
									title="unlock"
									onClick={() => (!isAllCOROutdoorShadesUnlocked && unlockAllShades())}
									className=" fa-fw"
									style={{ cursor: "pointer" }}
								>
									<FontAwesomeIcon
										className="icon-unlock unlock-all"
										transform="x-12 grow-6"
										icon={
											isAllCOROutdoorShadesUnlocked ? faUnlock : faLock
										}
									/>
								</span>
							)}
						</div>
					</th>
					<th className={currentQuoteType} colSpan={9}>
						<div
							className={`table-header ${quoteType}`}
							style={{ textAlign: 'center' }}
						>
							Outdoor Shades
						</div>
					</th>
				</tr>
				<tr>
					{columns.map((column) => (
						<th key={column.displayName}>
							{column.displayName}
						</th>
					))}
				</tr>
				{outdoorAssemblies.map((assembly) => (
					<COROutdoorTableRow
						unlockShadeBySequenceId={unlockShadeBySequenceId}
						quoteId={quoteId}
						sequenceId={assembly.sequence_id}
						ROOT={ROOT}
					/>

				))}
			</tbody>
		</Table>

	</div>);
};

export default COROutdoorTable;

